import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { Folder, FolderOpen } from "@mui/icons-material";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import GenreService from "./GenreServie";

export default function GenreTree({ callback, parentReload }) {
    const [treeData, setTreeData] = useState([]);

    useEffect(() => {
        GenreService.requestGenre().then((r) => {
            const data = transformToNestedData(r);
            setTreeData(data);
        });
    }, [parentReload]);

    const handleNodeSelect = (event, itemId) => {
        callback(itemId);
    };

    const renderTreeItems = (genres) => {
        return genres.map((genre) => (
            <TreeItem
                key={genre.id}
                itemId={genre.id.toString()}
                label={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {genre.children && genre.children.length > 0 ? (
                            <Folder sx={{ color: "#42B972" }} />
                        ) : (
                            <FolderOpen sx={{ color: "#42B972" }} />
                        )}
                        <Box sx={{ ml: 1 }}>{genre.name}</Box>
                    </Box>
                }
            >
                {genre.children && genre.children.length > 0 && renderTreeItems(genre.children)}
            </TreeItem>
        ));
    };

    return (
        <SimpleTreeView
            aria-label="genre tree"
            defaultExpanded={['root']}
            onSelectedItemsChange={handleNodeSelect}
        >
            {treeData.length > 0 && renderTreeItems(treeData)}
        </SimpleTreeView>
    );
}

// Function to transform flat data to nested structure (unchanged)
const transformToNestedData = (data) => {
    const idMap = new Map();
    const roots = [];

    data.forEach((item) => {
        idMap.set(item.id, { ...item, children: [] });
    });

    data.forEach((item) => {
        if (item.parentGenre) {
            const parent = idMap.get(item.parentGenre.id);
            if (parent) {
                parent.children.push(idMap.get(item.id));
            }
        } else {
            roots.push(idMap.get(item.id));
        }
    });

    // Sort roots and children by displayOrder
    const sortByDisplayOrder = (a, b) => a.displayOrder - b.displayOrder;

    // Sort the roots array
    roots.sort(sortByDisplayOrder);

    // Sort children of each parent by displayOrder
    idMap.forEach((item) => {
        if (item.children.length > 0) {
            item.children.sort(sortByDisplayOrder);
        }
    });

    return roots;
};
